export default __webpack_public_path__ + "static/media/errorImage.029045d0.png";